import { ETaskMemberType } from "../../types/task.types";
export var ETaskCustomFilter;
(function (ETaskCustomFilter) {
    ETaskCustomFilter["Archived"] = "ARCHIVED";
    ETaskCustomFilter["NotArchived"] = "NOT_ARCHIVED";
    ETaskCustomFilter["All"] = "ALL";
})(ETaskCustomFilter || (ETaskCustomFilter = {}));
export var getOpenTasksFilter = function () {
    return {
        filter: { finishedAt: { is: null } },
        rolesFilter: [ETaskMemberType.Executor],
    };
};
